export const RoutePath = {
  termsAndConditions: `/terms-and-conditions`,
  /** @deprecated replaced with /start */
  createOrganisation: `/create-organisation`,
  start: `/start`,
  /** @deprecated to be removed after it's renamed in whatsapp template */
  newQuestionnaire: `/new-questionnaire`,
  shortcut: `/shortcut`,
};
